var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hotel-all',{attrs:{"pageInfo":_vm.pageInfo,"showQuickSearch":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }